import { useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function SupporterVisibility() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const shown = !user.supporter_hidden;
  const toggle = async (v) => {
    setBusy(true);
    try { await api.put("/profile/supporter-visibility", { hidden: !v }); setUser({ ...user, supporter_hidden: !v }); toast.success(v ? "Du stehst auf der Dankes-Liste" : "Von der Dankes-Liste ausgetragen"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-rose-50 rounded-3xl p-6 border border-rose-200 flex items-center gap-3" data-testid="supporter-visibility">
      <Heart className="w-6 h-6 text-rose-500 fill-rose-500 shrink-0" />
      <div className="flex-1 min-w-0"><p className="font-bold">Danke für deine Unterstützung!</p><p className="text-xs text-slate-500">Auf der Dankes-Liste bei „Projekt unterstützen“ zeigen</p></div>
      <Switch checked={shown} disabled={busy} onCheckedChange={toggle} data-testid="supporter-visibility-switch" className="data-[state=checked]:bg-rose-500 data-[state=unchecked]:bg-slate-300" />
    </div>
  );
}
